import { Box, Modal } from '@mui/material'
import React, { useState } from 'react'
import ManageOnGoingAvailabilityModal from './ManageOnGoingAvailabilityModal'
import VacationTimeModal from './VacationTimeModal'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import AdjustComingHoursModal from './AdjustComingHoursModal'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  //   width: "25%",
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const UpdateAvailabilityModal = ({
  toggleUpdateAvailabilityModal,
  modalOpen,
}) => {
  const [
    toggleOngoingAvailabilityModal,
    setToggleOngoingAvailabilityModal,
  ] = useState(false)
  const [isVacationTime, setIsVacationTime] = useState(false)
  const [adjustComingHoursModal, setAdjustComingHoursModal] = useState(false)

  const handleOngoingAvailabilityModal = (type = '') => {
    if (modalOpen && !toggleOngoingAvailabilityModal) {
      toggleUpdateAvailabilityModal(false)
    }
    setToggleOngoingAvailabilityModal(!toggleOngoingAvailabilityModal)
  }

  const handleVacationTimeModal = (type = '') => {
    if (modalOpen && !toggleOngoingAvailabilityModal) {
      toggleUpdateAvailabilityModal(false)
    }
    setIsVacationTime(!isVacationTime)
  }

  const handleAdjustComingHoursModal = (type = '') => {
    if (modalOpen) {
      toggleUpdateAvailabilityModal(false)
    }
    setAdjustComingHoursModal(!adjustComingHoursModal)
  }

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => toggleUpdateAvailabilityModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="update-availability-modal">
          <div className="availability-modal-wrapper">
            <h3 className="fs-24">Update Availability</h3>
            <p className="desc-text mt-3 mb-2">
              Need to update your weekly availability?
            </p>
            <div
              className="update-availability-btn text-white py-2 px-2 pointer"
              onClick={handleOngoingAvailabilityModal}
            >
              <p className="fs-12 text-capitalize text-white d-inline-block font-weight-bold">
                Manage ongoing availability{' '}
              </p>
              <span className="float-end">
                <ChevronRightIcon />
              </span>
            </div>
            <p className="desc-text mt-3 mb-2">
              Taking break block off some time on your calendar.
            </p>
            <div
              className="update-availability-btn text-white py-2 px-2 pointer"
              onClick={handleVacationTimeModal}
            >
              <p className="fs-12 text-capitalize text-white d-inline-block font-weight-bold">
                Manage vacation time
              </p>
              <span className="float-end">
                <ChevronRightIcon />
              </span>
            </div>
            <p className="desc-text mt-3 mb-2">
              Need to make a one-time adjustment to your <br /> upcoming
              availability?
            </p>
            <div
              className="update-availability-btn text-white py-2 px-2 pointer"
              onClick={handleAdjustComingHoursModal}
            >
              <p className="fs-12 text-capitalize text-white d-inline-block font-weight-bold">
                Adjust coming hour{' '}
              </p>
              <span className="float-end">
                <ChevronRightIcon />
              </span>
            </div>
          </div>
        </Box>
      </Modal>
      <ManageOnGoingAvailabilityModal
        toggleOngoingAvailabilityModal={handleOngoingAvailabilityModal}
        modalOpen={toggleOngoingAvailabilityModal}
      />
      <VacationTimeModal
        toggleVacationTimeModal={handleVacationTimeModal}
        modalOpen={isVacationTime}
      />
      <AdjustComingHoursModal
        handleAdjustComingHoursModal={handleAdjustComingHoursModal}
        modalOpen={adjustComingHoursModal}
      />
    </>
  )
}

export default UpdateAvailabilityModal
